module.exports = __webpack_public_path__ + "img/gi_screening_logo.392eaef5.png";